import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogTitle: {
    id: 'frontbucket.branches.deleteBranchDialogTitle',
    description: 'Title for the delete branch dialog for a git repository',
    defaultMessage: 'Delete branch',
  },
  dialogDescription: {
    id: 'frontbucket.branches.deleteBranchDialogDescription',
    description: 'The message in the delete branch dialog for a git repository',
    defaultMessage: 'Are you sure you want to delete the branch {branchLabel}?',
  },
  deleteButton: {
    id: 'frontbucket.branches.deleteBranchDialogDeleteButton',
    description:
      'Text in the delete button in the delete branch dialog for a git repository',
    defaultMessage: 'Delete',
  },
  cancelButton: {
    id: 'frontbucket.branches.deleteBranchDialogCancelButton',
    description: 'Text for the cancel button in the delete branch dialog.',
    defaultMessage: 'Cancel',
  },
});
